export interface HizmetFaq {
  q: string;
  a: string;
}

export interface HizmetData {
  slug: string;
  name: string;
  shortName: string;
  metaTitle: string;
  metaDesc: string;
  heroTitle: string;
  heroDesc: string;
  icon: string;
  img: string;
  about: string;
  details: string[];
  steps: { title: string; desc: string }[];
  faqs: HizmetFaq[];
  relatedServices: string[];
}

export const hizmetData: HizmetData[] = [
  {
    slug: 'acil-kapi-acma',
    name: 'Acil Kapı Açma',
    shortName: 'Kapı Açma',
    metaTitle: 'Acil Kapı Açma Beylikdüzü | Alfa Çilingir 7/24 - 0541 624 79 82',
    metaDesc: 'Beylikdüzü, Esenyurt, Büyükçekmece ve Bahçeşehir\'de 7/24 acil kapı açma hizmeti. Kilitli kalan kapıları hasarsız açıyoruz. 15 dakikada yanınızda. 0541 624 79 82',
    heroTitle: 'Acil Kapı Açma',
    heroDesc: 'Kapınız kilitli mi kaldı? Panik yapmayın. Alfa Çilingir ekibi 15 dakikada adresinizde, hasarsız açma garantisiyle.',
    icon: 'ri-door-open-line',
    img: 'https://readdy.ai/api/search-image?query=professional%20locksmith%20carefully%20opening%20residential%20apartment%20door%20with%20specialized%20tools%2C%20close%20up%20skilled%20hands%20working%20on%20modern%20door%20lock%2C%20professional%20service%2C%20Istanbul%20Turkey%2C%20warm%20indoor%20lighting%2C%20no%20damage%20technique&width=1200&height=600&seq=hld001&orientation=landscape',
    about: 'Evinizin, işyerinizin veya aracınızın kapısı kilitli kaldıysa panik yapmayın. Alfa Çilingir ekibi çağrı aldıktan sonra ortalama 15 dakika içinde adresinizde olur. Tüm kapı tipleri için hasarsız açma garantisi veriyoruz. Daire kapısı, işyeri kapısı, bodrum ve depo kapısı, apartman giriş kapısı dahil her türlü kapıda uzman müdahale.',
    details: [
      'Daire ve ev kapısı açma',
      'İşyeri ve ofis kapısı açma',
      'Bodrum & depo kapısı açma',
      'Apartman giriş kapısı açma',
      'Hasarsız açma garantisi',
      'Tüm kilit tipleri',
    ],
    steps: [
      { title: 'Hemen Arayın', desc: '0541 624 79 82 numarasını arayın, adresinizi bildirin.' },
      { title: '15 Dakikada Geliyoruz', desc: 'Ekibimiz ortalama 15 dakika içinde adresinizde olur.' },
      { title: 'Hasarsız Açma', desc: 'Özel ekipmanlarla kapınıza zarar vermeden açıyoruz.' },
      { title: 'İşlem Tamamlandı', desc: 'Fiyatı önceden bildiriyoruz, gizli ücret yok.' },
    ],
    faqs: [
      { q: 'Kapı açma işlemi ne kadar sürer?', a: 'Standart bir kapı açma işlemi genellikle 5-15 dakika sürer. Çelik kapılar veya özel kilitler biraz daha uzun sürebilir ancak ekibimiz her durumda en hızlı çözümü sunar.' },
      { q: 'Kapıyı açarken zarar verir misiniz?', a: 'Hayır! Alfa Çilingir olarak hasarsız açma tekniklerini kullanıyoruz. Özel ekipmanlarımızla kapınıza, kilide veya çerçeveye zarar vermeden açıyoruz.' },
      { q: 'Gece kapı açma hizmeti var mı?', a: 'Evet, 7/24 kesintisiz hizmet veriyoruz. Gece yarısı, hafta sonu veya resmi tatillerde de hemen arayabilirsiniz.' },
      { q: 'Kapı açma fiyatı ne kadar?', a: 'Fiyatlar kapı tipine, kilit modeline ve saate göre değişmektedir. İşlem öncesinde net fiyat bilgisi veriyoruz, gizli ücret yoktur. Bilgi için: 0541 624 79 82' },
      { q: 'Hangi bölgelerde kapı açma hizmeti veriyorsunuz?', a: 'Beylikdüzü, Esenyurt, Büyükçekmece ve Bahçeşehir\'in tüm mahalle ve semtlerinde 7/24 acil kapı açma hizmeti veriyoruz.' },
    ],
    relatedServices: ['kilit-degistirme', 'celik-kapi-acma', 'anahtar-kopyalama'],
  },
  {
    slug: 'kilit-degistirme',
    name: 'Kilit Değiştirme',
    shortName: 'Kilit Değiştirme',
    metaTitle: 'Kilit Değiştirme Beylikdüzü | Alfa Çilingir 7/24 - 0541 624 79 82',
    metaDesc: 'Beylikdüzü, Esenyurt, Büyükçekmece ve Bahçeşehir\'de profesyonel kilit değiştirme hizmeti. Silindir kilit, çelik kapı kilidi, akıllı kilit montajı. 0541 624 79 82',
    heroTitle: 'Kilit Değiştirme',
    heroDesc: 'Eski, hasarlı veya güvenliğinden şüphe duyduğunuz kilitleri en kaliteli markalarla değiştiriyoruz. Taşınma sonrası güvenliğiniz için hemen arayın.',
    icon: 'ri-lock-2-line',
    img: 'https://readdy.ai/api/search-image?query=professional%20locksmith%20installing%20brand%20new%20high%20security%20door%20lock%20cylinder%2C%20replacing%20old%20lock%2C%20modern%20apartment%20steel%20door%2C%20close%20up%20detail%20work%2C%20professional%20tools%20laid%20out%2C%20Istanbul%20Turkey&width=1200&height=600&seq=hld002&orientation=landscape',
    about: 'Eski, hasarlı veya güvenliğinden şüphe duyduğunuz kilitlerini en kaliteli markalarla değiştiriyoruz. Taşınma sonrası kilit değişimi, kiracı çıkışı sonrası güvenlik güncellemesi, anahtar kaybı sonrası güvenlik önlemi gibi durumlarda hızlı ve profesyonel hizmet sunuyoruz. Silindir kilit, çelik kapı kilidi, barel değişimi ve akıllı kilit montajı dahil tüm kilit tiplerinde uzman hizmet.',
    details: [
      'Silindir kilit değişimi',
      'Çelik kapı kilit değişimi',
      'Barel değişimi',
      'Akıllı kilit montajı',
      'Tüm marka ve modeller',
      'Garantili ürünler',
    ],
    steps: [
      { title: 'Kilit Tespiti', desc: 'Mevcut kilidi inceleyip en uygun yeni kilidi belirliyoruz.' },
      { title: 'Ürün Seçimi', desc: 'Güvenlik ihtiyacınıza göre kaliteli kilit seçenekleri sunuyoruz.' },
      { title: 'Profesyonel Montaj', desc: 'Uzman ekibimiz kilidi hızlı ve doğru şekilde monte eder.' },
      { title: 'Test ve Teslim', desc: 'Kilidi test edip yedek anahtarlarla birlikte teslim ediyoruz.' },
    ],
    faqs: [
      { q: 'Kilit değiştirme ne zaman gereklidir?', a: 'Taşınma sonrası, kiracı değişiminde, anahtar kaybında, kilit hasarında veya güvenliğinizden şüphe duyduğunuzda kilit değiştirmenizi öneririz.' },
      { q: 'Hangi kilit markalarını kullanıyorsunuz?', a: 'Kale, Mul-T-Lock, Abloy, Yale gibi güvenilir markaların ürünlerini kullanıyoruz. Bütçenize ve güvenlik ihtiyacınıza göre seçenekler sunuyoruz.' },
      { q: 'Kilit değiştirme ne kadar sürer?', a: 'Standart bir silindir kilit değişimi 15-30 dakika sürer. Çelik kapı kilidi veya akıllı kilit montajı biraz daha uzun sürebilir.' },
      { q: 'Kilit değiştirme fiyatı ne kadar?', a: 'Fiyat kilit tipine ve markasına göre değişir. İşlem öncesinde net fiyat bilgisi veriyoruz. Bilgi için: 0541 624 79 82' },
      { q: 'Akıllı kilit montajı yapıyor musunuz?', a: 'Evet, şifreli, parmak izli ve telefon kontrollü akıllı kilit montajı yapıyoruz. Güvenliğinizi bir üst seviyeye taşıyın.' },
    ],
    relatedServices: ['acil-kapi-acma', 'celik-kapi-acma', 'anahtar-kopyalama'],
  },
  {
    slug: 'celik-kapi-acma',
    name: 'Çelik Kapı Açma',
    shortName: 'Çelik Kapı Açma',
    metaTitle: 'Çelik Kapı Açma Beylikdüzü | Alfa Çilingir 7/24 - 0541 624 79 82',
    metaDesc: 'Beylikdüzü, Esenyurt, Büyükçekmece ve Bahçeşehir\'de 7/24 çelik kapı açma hizmeti. Tüm marka çelik kapılarda hasarsız açma. 15 dakikada yanınızda. 0541 624 79 82',
    heroTitle: 'Çelik Kapı Açma',
    heroDesc: 'Tüm marka ve model çelik kapılarda hasarsız açma. Özel ekipmanlarla kapınıza zarar vermeden, hızlı ve güvenli çözüm.',
    icon: 'ri-shield-keyhole-line',
    img: 'https://readdy.ai/api/search-image?query=heavy%20duty%20steel%20security%20door%20with%20multiple%20lock%20points%20in%20apartment%20building%20hallway%2C%20professional%20locksmith%20examining%20door%20mechanism%2C%20Turkey%20residential%20building%2C%20close%20up%20door%20handle%20and%20lock&width=1200&height=600&seq=hld003&orientation=landscape',
    about: 'Çelik kapılar özel ekipman ve uzmanlık gerektirir. Alfa Çilingir ekibi tüm marka ve model çelik kapılarda hasarsız açma konusunda deneyimlidir. Kale, Çelikkapı, Doğtaş, Gordion ve diğer tüm markalarda uzman müdahale. Kapınıza zarar vermeden, hızlı ve güvenli şekilde açıyoruz.',
    details: [
      'Tüm marka çelik kapılar',
      'Hasarsız açma garantisi',
      'Kale, Çelikkapı, Doğtaş ve daha fazlası',
      'Kilit değişimi dahil seçenek',
      'Acil müdahale',
      '7/24 hizmet',
    ],
    steps: [
      { title: 'Acil Çağrı', desc: 'Hemen arayın, kapı marka ve modelini bildirin.' },
      { title: 'Uzman Ekip', desc: 'Çelik kapı uzmanı ekibimiz 15 dakikada adresinizde.' },
      { title: 'Özel Ekipman', desc: 'Çelik kapıya özel aletlerle hasarsız açma işlemi.' },
      { title: 'Güvenli Teslim', desc: 'Kapı açıldıktan sonra kilit kontrolü ve gerekirse değişim.' },
    ],
    faqs: [
      { q: 'Çelik kapı açma ne kadar sürer?', a: 'Çelik kapı tipine ve kilit modeline göre 15-45 dakika arasında değişir. Ekibimiz en hızlı çözümü sunar.' },
      { q: 'Çelik kapıyı açarken zarar verir misiniz?', a: 'Hayır, özel ekipmanlarımızla çelik kapınıza, kilide veya çerçeveye zarar vermeden açıyoruz. Hasarsız açma garantisi veriyoruz.' },
      { q: 'Hangi marka çelik kapıları açabiliyorsunuz?', a: 'Kale, Çelikkapı, Doğtaş, Gordion, Çelik-İş ve diğer tüm marka çelik kapılarda hizmet veriyoruz.' },
      { q: 'Çelik kapı açma fiyatı ne kadar?', a: 'Fiyat kapı tipine ve saate göre değişir. İşlem öncesinde net fiyat bildiriyoruz. Bilgi için: 0541 624 79 82' },
      { q: 'Çelik kapı açıldıktan sonra kilit değişimi yapıyor musunuz?', a: 'Evet, kapı açıldıktan sonra isterseniz aynı anda kilit değişimi de yapıyoruz. Güvenliğiniz için önerilir.' },
    ],
    relatedServices: ['acil-kapi-acma', 'kilit-degistirme', 'kasa-acma'],
  },
  {
    slug: 'oto-cilingir',
    name: 'Oto Çilingir',
    shortName: 'Oto Çilingir',
    metaTitle: 'Oto Çilingir Beylikdüzü | Alfa Çilingir 7/24 - 0541 624 79 82',
    metaDesc: 'Beylikdüzü, Esenyurt, Büyükçekmece ve Bahçeşehir\'de 7/24 oto çilingir hizmeti. Araç kapısı açma, anahtar kopyalama, immobilizer çözümü. 0541 624 79 82',
    heroTitle: 'Oto Çilingir',
    heroDesc: 'Araç anahtarınızı kaybettiniz mi, kırdınız mı veya araç içinde mi unuttunuz? Tüm araç markalarında 7/24 profesyonel çözüm.',
    icon: 'ri-car-line',
    img: 'https://readdy.ai/api/search-image?query=automotive%20locksmith%20professional%20opening%20modern%20car%20door%20with%20specialized%20tools%2C%20urban%20street%20background%2C%20skilled%20technician%20in%20work%20uniform%2C%20close%20up%20car%20door%20lock%2C%20Istanbul%20Turkey&width=1200&height=600&seq=hld004&orientation=landscape',
    about: 'Araç anahtarınızı kaybettiniz, kırdınız veya araç içinde unuttunuz mu? Alfa Çilingir oto çilingir ekibi tüm araç marka ve modellerinde anahtar kopyalama, kapı açma ve immobilizer çözümleri sunuyor. Toyota, Honda, Ford, Volkswagen, Renault, Fiat ve daha fazlası. Araç güvenliğinizi tehlikeye atmadan hızlı çözüm.',
    details: [
      'Tüm araç markaları',
      'Araç kapısı açma',
      'Anahtar kopyalama',
      'Immobilizer çözümü',
      'Yedek anahtar yapımı',
      'Kontak değişimi',
    ],
    steps: [
      { title: 'Araç Bilgisi', desc: 'Araç marka, model ve plakasını bildirin.' },
      { title: 'Uzman Ekip', desc: 'Oto çilingir uzmanımız 15 dakikada yanınızda.' },
      { title: 'Güvenli Açma', desc: 'Araca zarar vermeden kapı açma veya anahtar işlemi.' },
      { title: 'Çözüm Tamamlandı', desc: 'Yedek anahtar veya kopyalama seçeneği sunuyoruz.' },
    ],
    faqs: [
      { q: 'Hangi araç markalarında hizmet veriyorsunuz?', a: 'Toyota, Honda, Ford, Volkswagen, Renault, Fiat, Hyundai, Kia, BMW, Mercedes ve diğer tüm araç markalarında hizmet veriyoruz.' },
      { q: 'Araç anahtarı kopyalama ne kadar sürer?', a: 'Standart araç anahtarı kopyalama 30-60 dakika sürer. Transponder veya akıllı anahtar işlemleri biraz daha uzun sürebilir.' },
      { q: 'Araç içinde kalan anahtarı çıkarabilir misiniz?', a: 'Evet, araç içinde kalan anahtarı araca zarar vermeden çıkarıyoruz. Hemen arayın: 0541 624 79 82' },
      { q: 'Immobilizer sorunu çözüyor musunuz?', a: 'Evet, immobilizer (çalışmaz hale getirme sistemi) sorunlarında uzman çözüm sunuyoruz. Araç başlamıyorsa hemen arayın.' },
      { q: 'Oto çilingir fiyatı ne kadar?', a: 'Fiyat araç tipine ve yapılacak işleme göre değişir. İşlem öncesinde net fiyat bildiriyoruz. Bilgi için: 0541 624 79 82' },
    ],
    relatedServices: ['acil-kapi-acma', 'anahtar-kopyalama', 'kilit-degistirme'],
  },
  {
    slug: 'kasa-acma',
    name: 'Kasa Açma',
    shortName: 'Kasa Açma',
    metaTitle: 'Kasa Açma Beylikdüzü | Alfa Çilingir 7/24 - 0541 624 79 82',
    metaDesc: 'Beylikdüzü, Esenyurt, Büyükçekmece ve Bahçeşehir\'de 7/24 kasa açma hizmeti. Şifreli ve anahtarlı kasa açma, kombinasyon sıfırlama. 0541 624 79 82',
    heroTitle: 'Kasa Açma',
    heroDesc: 'Şifreli veya anahtarlı kasaları güvenle açıyor, kombinasyon sıfırlama ve kilit değişimi yapıyoruz. Ev, ofis ve otel kasaları.',
    icon: 'ri-safe-line',
    img: 'https://readdy.ai/api/search-image?query=professional%20locksmith%20opening%20combination%20safe%20box%20in%20office%20environment%2C%20security%20safe%20with%20dial%20combination%2C%20skilled%20technician%20with%20specialized%20tools%2C%20focused%20professional%20work%2C%20clean%20background&width=1200&height=600&seq=hld005&orientation=landscape',
    about: 'Şifreli veya anahtarlı kasaları güvenle açıyor, kombinasyon sıfırlama ve kilit değişimi yapıyoruz. Ev kasaları, ofis kasaları ve otel kasaları dahil tüm kasa tiplerinde hizmet. Şifrenizi unuttunuz, anahtarınızı kaybettiniz veya kasa arızalandıysa uzman ekibimiz hızlı çözüm sunar.',
    details: [
      'Şifreli kasa açma',
      'Anahtarlı kasa açma',
      'Kombinasyon sıfırlama',
      'Kasa kilit değişimi',
      'Ev, ofis ve otel kasaları',
      'Tüm marka kasalar',
    ],
    steps: [
      { title: 'Kasa Bilgisi', desc: 'Kasa marka, model ve sorun türünü bildirin.' },
      { title: 'Uzman Değerlendirme', desc: 'Kasa uzmanımız en uygun açma yöntemini belirler.' },
      { title: 'Güvenli Açma', desc: 'Kasanıza zarar vermeden profesyonel açma işlemi.' },
      { title: 'Kombinasyon Güncelleme', desc: 'İsterseniz yeni şifre veya kilit ayarı yapıyoruz.' },
    ],
    faqs: [
      { q: 'Kasa şifremi unuttum, ne yapmalıyım?', a: 'Hemen arayın: 0541 624 79 82. Uzman ekibimiz kasanıza zarar vermeden açar ve yeni kombinasyon ayarlar.' },
      { q: 'Hangi marka kasaları açabiliyorsunuz?', a: 'Çelik-İş, Kale, Sentry, Burg-Wächter ve diğer tüm marka kasalarda hizmet veriyoruz.' },
      { q: 'Kasa açma ne kadar sürer?', a: 'Kasa tipine ve sorunun niteliğine göre 30 dakika ile 2 saat arasında değişir.' },
      { q: 'Kasa açma fiyatı ne kadar?', a: 'Fiyat kasa tipine ve yapılacak işleme göre değişir. İşlem öncesinde net fiyat bildiriyoruz. Bilgi için: 0541 624 79 82' },
      { q: 'Kasa açıldıktan sonra kombinasyon değiştirebilir misiniz?', a: 'Evet, kasa açıldıktan sonra yeni kombinasyon ayarı veya kilit değişimi yapıyoruz.' },
    ],
    relatedServices: ['acil-kapi-acma', 'celik-kapi-acma', 'kilit-degistirme'],
  },
  {
    slug: 'anahtar-kopyalama',
    name: 'Anahtar Kopyalama',
    shortName: 'Anahtar Kopyalama',
    metaTitle: 'Anahtar Kopyalama Beylikdüzü | Alfa Çilingir 7/24 - 0541 624 79 82',
    metaDesc: 'Beylikdüzü, Esenyurt, Büyükçekmece ve Bahçeşehir\'de profesyonel anahtar kopyalama hizmeti. Ev, araç, ofis anahtarı kopyalama ve yedek anahtar yapımı. 0541 624 79 82',
    heroTitle: 'Anahtar Kopyalama',
    heroDesc: 'Her türlü anahtar kopyalama ve yedek anahtar yapımı. Ev, araç, ofis ve özel anahtarlar dahil hızlı ve hassas kopyalama.',
    icon: 'ri-key-2-line',
    img: 'https://readdy.ai/api/search-image?query=professional%20key%20cutting%20machine%20duplicating%20house%20key%2C%20locksmith%20workshop%2C%20various%20types%20of%20keys%20hanging%2C%20modern%20key%20copying%20equipment%2C%20close%20up%20detail%2C%20professional%20service%20environment&width=1200&height=600&seq=hld006&orientation=landscape',
    about: 'Her türlü anahtar kopyalama ve yedek anahtar yapımı hizmetimizle yedek anahtarınızı hızlıca çıkarıyoruz. Ev anahtarı, araç anahtarı, ofis anahtarı ve özel anahtarlar dahil. Modern anahtar kesme makinelerimizle hassas ve dayanıklı kopyalar üretiyoruz. Yedek anahtar bulundurmak, acil durumlar için en akıllı önlemdir.',
    details: [
      'Ev anahtarı kopyalama',
      'Araç anahtarı kopyalama',
      'Ofis & depo anahtarı',
      'Özel anahtar yapımı',
      'Transponder anahtar',
      'Çip programlama',
    ],
    steps: [
      { title: 'Anahtar Getirin', desc: 'Kopyalanacak anahtarı getirin veya biz gelelim.' },
      { title: 'Analiz', desc: 'Anahtar tipi ve güvenlik seviyesi belirlenir.' },
      { title: 'Hassas Kopyalama', desc: 'Modern makinelerle hassas ve dayanıklı kopya üretilir.' },
      { title: 'Test ve Teslim', desc: 'Kopya test edilip teslim edilir.' },
    ],
    faqs: [
      { q: 'Hangi anahtar tiplerini kopyalayabiliyorsunuz?', a: 'Standart ev anahtarları, güvenlik anahtarları, araç anahtarları, transponder anahtarlar, kart anahtarlar ve özel anahtarlar dahil tüm tiplerde kopyalama yapıyoruz.' },
      { q: 'Araç anahtarı kopyalama mümkün mü?', a: 'Evet, çoğu araç markasında anahtar kopyalama ve transponder programlama yapıyoruz. Araç marka ve modelini bildirin.' },
      { q: 'Anahtar kopyalama ne kadar sürer?', a: 'Standart ev anahtarı kopyalama 5-10 dakika sürer. Araç anahtarı veya transponder programlama 30-60 dakika sürebilir.' },
      { q: 'Anahtar kopyalama fiyatı ne kadar?', a: 'Fiyat anahtar tipine göre değişir. Standart anahtarlar çok uygun fiyatlıdır. Bilgi için: 0541 624 79 82' },
      { q: 'Kaç adet yedek anahtar yaptırmalıyım?', a: 'En az 2 yedek anahtar bulundurmanızı öneririz. Aile üyeleri veya güvendiğiniz kişilere birer adet vermeniz acil durumlarda büyük kolaylık sağlar.' },
    ],
    relatedServices: ['acil-kapi-acma', 'kilit-degistirme', 'oto-cilingir'],
  },
];

export const getHizmetBySlug = (slug: string): HizmetData | undefined =>
  hizmetData.find((h) => h.slug === slug);

export const getRelatedHizmetler = (slugs: string[]): HizmetData[] =>
  hizmetData.filter((h) => slugs.includes(h.slug));
